export default __webpack_public_path__ + "static/Pomorskie_Kompetencje_Jutra_LOGO_1-01-d8b5fd2ca7ac13f0a55ff3f0fea3359c.jpg";